import * as z from "zod";
import { SegmentConditionBlock } from "./segment-types";
import {
  conditionBlockSchema,
  conditionBlockToZod,
} from "./segment-zod-schema";

/**
 * Flow inline segments persist the builder's flat shape; customer groups convert
 * first. Validating through the converter avoids a second condition vocabulary.
 */

const asConverted = (block: unknown) => {
  try {
    return conditionBlockToZod(block as SegmentConditionBlock);
  } catch {
    return block;
  }
};

export const legacyFlatInlineSegmentConditionBlockSchema = z
  .custom<SegmentConditionBlock>(
    (block) => typeof block === "object" && block !== null,
  )
  .superRefine((block, ctx) => {
    const result = conditionBlockSchema.safeParse(asConverted(block));
    if (!result.success) {
      for (const issue of result.error.issues) {
        ctx.addIssue({
          code: "custom",
          path: issue.path,
          message: issue.message,
        });
      }
    }
  });
